import { IModuleID } from "@propely/propely-typings";
import { useProperties } from "@src/data-hooks/property/property.service";
import { getCurrentUser } from "@src/auth/getCurrentUser";
import { AppModules } from "@src/to-be-removed/LocalData/Property/AppModules";

/**
 * Hook to check the status of modules are enabled for the current user.
 * @param propertyIDs Optional list of properties to check. Will return true for a module if it is enabled for any of the properties.
 * @returns An object with the status of each module
 */
export const useModulesStatus = (propertyIDs: string[] | undefined = undefined) => {
  // Fetches needed property data
  const { user } = getCurrentUser();
  const { properties } = useProperties(propertyIDs || user?.properties || []);

  // Sets default modules status
  const staticModules = AppModules.getModules();
  const modulesStatus: { [key in IModuleID]: boolean } = staticModules.reduce(
    (acc, m) => ({ ...acc, [m.id]: false }),
    {} as { [key in IModuleID]: boolean }
  );

  // Checks if module is enabled for any of the properties
  for (const module of Object.keys(modulesStatus) as IModuleID[]) {
    let hasSet = false;
    for (const property of properties) {
      if (property?.modules?.[module]) {
        hasSet = true;
        if (property.modules[module]?.active) {
          modulesStatus[module] = true;
          break;
        }
      }
    }

    // If module is not set for any of the properties, check if it is set as out
    if (!hasSet) {
      modulesStatus[module] = staticModules.find((m) => m.id === module)?.opt === "out";
    }
  }

  return modulesStatus;
};
